import React from "react";
import { Sidebar } from "primereact/sidebar";
import { isMobileUserAgent } from "../helpers/helpers";
import SizeReview from "./SizeReview";

function SizeSidebar({ isVisible, setIsVisible }) {
    const isMobile = isMobileUserAgent();
    return (
        <Sidebar
            className={isMobile ? "" : "w-1/3"}
            position="right"
            visible={isVisible}
            onHide={() => setIsVisible(false)}
            fullScreen={isMobile}
        >
            <SizeReview />
        </Sidebar>
    );
}

export default SizeSidebar;
